import authenticatedRequest from "~/backend/authenticatedRequest";
import fetchBackend from "~/backend/fetchHelpData";
import createPromiseThunk from "~/rx/lib/createPromiseThunk";

const helpData = createPromiseThunk({
    func: ({dispatch, getConfig}) => {
        return fetchBackend(getConfig().baseUrl, (foo) => authenticatedRequest(foo, dispatch));
    },
    name: 'helpData'
});

const reduceHelpData = helpData.reduce,
    HELP_DATA_TYPES = helpData.types,
    fetchHelpData = helpData.execute;

export { reduceHelpData, HELP_DATA_TYPES, fetchHelpData };